import { markCompanyChatUnread } from '../components/chat/chatApi';

/** Ручная пометка чата компании непрочитанным (+1 к бейджу, если сообщений нет). */
export async function applyMarkCompanyChatUnread({
    userId,
    getCurrentBadge,
    patchChatBadge,
    refreshAccountBadges,
}) {
    const uid = Number(userId);
    if (!uid) return;
    const current = Number(getCurrentBadge?.(uid)) || 0;
    patchChatBadge?.(uid, Math.max(current, 1));
    try {
        await markCompanyChatUnread(uid);
    } catch (e) {
        console.warn('markCompanyChatUnread failed:', e);
    } finally {
        refreshAccountBadges?.();
    }
}
